<div class="whitebg d-flex">
  <div class="sidebar">
    <app-sidebar> </app-sidebar>
  </div>
  <div style="width: calc(100% - 80px) !important; height: 100%">
    <router-outlet></router-outlet>
  </div>
</div>
